export enum METHOD_API {
    GENERATE_DELIVERY_NOTES = 'dlad_wms.api.generate_delivery_notes',
    MARK_AS_COMPLETE = 'dlad_wms.api.mark_as_complete',
    MARK_AS_PACK = 'dlad_wms.api.mark_as_pack',
    GENERATE_INVOICE = 'dlad_wms.dln_to_inv.enqueue',
    PRINT_LABEL = 'dlad_wms.api.get_print_label'

}